import { TweenMax } from "gsap/all";

export const setTweenMaxAppear = _ => {
  return TweenMax.fromTo(
    ".nav-body",
    0.3,
    { transformOrigin: "50% 0%", scaleY: 0, scaleX: 1 },
    {
      scaleY: 1,
      scaleX: 1
    }
  );
};

export const setTweenMaxDisappear = _ => {
  return TweenMax.fromTo(
    ".nav-body",
    0.3,
    { transformOrigin: "50% 0%", scaleY: 1, scaleX: 1 },
    { scaleY: 0, scaleX: 1 }
  );
};



// WEBPACK FOOTER //
// ./src/js/tweenmax.js